const state = {
  orderIds: []
}

const mutations = {
  SET_ORDER_IDS: (state, ids) => {
    state.orderIds = ids
  }
}

const actions = {
  setOrderIds({commit}, ids) {
    commit('SET_ORDER_IDS', ids)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
